<template>
  <div v-if="column.field != null" class="px-1">
    <RouterLink
      v-if="column.field === 'reference' && commissionNote.id"
      :to="{
        name: 'commission_note_show_route',
        params: { id: commissionNote.id }
      }"
      class="block truncate p-3 font-semibold text-primary"
    >
      {{ commissionNote[column.field] }}
    </RouterLink>
    <AmountFormatter
      v-else-if="
        column.type === 'currency' || column.type === 'currency_invoicing'
      "
      :amount="commissionNote[column.field]"
      class="truncate leading-4 font-medium"
    />
    <div v-else-if="isLabel" class="flex justify-center">
      <BaseLabel
        :content="commissionNote[column.field].value"
        :color="commissionNote[column.field].color"
      />
    </div>
    <div v-else class="truncate" v-text="commissionNote[column.field]" />
  </div>
</template>

<script>
import AmountFormatter from '@c/AmountFormatter.vue'
import BaseLabel from '@c/addf-package/components/BaseLabel/BaseLabel.vue'

export default {
  name: 'CommissionNoteCell',
  components: { AmountFormatter, BaseLabel },
  props: {
    column: { type: Object, required: true },
    commissionNote: { type: Object, required: true }
  },
  computed: {
    isLabel() {
      const value = this.commissionNote[this.column.field]
      return value !== null && typeof value === 'object' && 'value' in value
    }
  }
}
</script>
